import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import { ActivityFeedContentEnum } from 'redux-store/slices/side-panel-slice';
import { styles } from '../../styles/styles';
import { ActivityFeedTabs } from './components/activity-feed-tabs';
import { ActivityFeedSearch } from './components/activity-feed-search';
import { ActivityFeedFilter } from './components/activity-feed-filter';
import { ActivityFeedClose } from './components/activity-feed-close';

interface IProps {
  showTabs?: boolean;
  activityFeedContent?: ActivityFeedContentEnum;
  onTabChange?: (value: ActivityFeedContentEnum) => void;
  onSetSearchQuery: (query: string) => void;
  onClose?: () => void;
  resetFilters?: () => void;
}

const ActivityFeedHeader: FC<IProps> = ({
  showTabs = false,
  activityFeedContent = ActivityFeedContentEnum.FEED,
  onTabChange,
  onSetSearchQuery,
  onClose,
  resetFilters,
}) => {
  const [showSearch, setShowSearch] = useState(false);

  const handleTabChange = (value: ActivityFeedContentEnum) => {
    onTabChange?.(value);
    resetFilters?.();
  };

  const onSearchOpen = () => setShowSearch(true);

  const onSearchClose = () => {
    setShowSearch(false);
    onSetSearchQuery('');
  };

  const handleClose = () => {
    onClose?.();
    resetFilters?.();
  };

  return (
    <Grid sx={styles.header}>
      {showTabs && !showSearch && (
        <ActivityFeedTabs
          value={activityFeedContent}
          onChange={handleTabChange}
        />
      )}

      {activityFeedContent === ActivityFeedContentEnum.FEED && (
        <Grid sx={styles.searchAndFilterContainer}>
          <ActivityFeedSearch
            showSearch={showSearch}
            onSearchClose={onSearchClose}
            onSearchOpen={onSearchOpen}
            onSetSearchQuery={onSetSearchQuery}
          />
          <ActivityFeedFilter />
        </Grid>
      )}

      {onClose && <ActivityFeedClose onClose={handleClose} />}
    </Grid>
  );
};

export default ActivityFeedHeader;
